import React from "react";
import {
  Card,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";

const ImageExperienceCard = ({
  logoSrc,
  company,
  subtitle,
  link,
  time,
  description,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        padding: 2,
        gap: 2,
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          width: isMobile ? "100%" : "350px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={logoSrc}
          alt={`${company} logo`}
          sx={{
            width: "200px",
          }}
        />
      </Box>

      {/* Details */}
      <Box sx={{ flexGrow: 1, textAlign: isMobile ? "center" : "left" }}>
        <Typography variant="h6">{company}</Typography>
        <Typography variant="body2" color="textSecondary">
          {time}
        </Typography>

        {/* Experience Points */}
        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {description}
          </Typography>
        </Box>

        <Button
          variant="contained"
          color="primary"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<LaunchIcon />}
          sx={{ mt: 2 }}
        >
          {subtitle}
        </Button>
      </Box>
    </Card>
  );
};

export default ImageExperienceCard;
